import axiosInstance from './axios.service';

const compradorService = {
  getCompradores: async (skip, limit) => {
    const { data } = await axiosInstance.get(`/api/compradores/${skip}/${limit}`);
    return data;
  },

  getComprador: async id => {
    const { data } = await axiosInstance.get(`/api/compradores/${id}`);
    return data;
  },

  createComprador: async compradorData => {
    const { data } = await axiosInstance.post('/api/compradores', compradorData);
    return data;
  },

  updateComprador: async (id, compradorData) => {
    const { data } = await axiosInstance.put(`/api/compradores/${id}`, compradorData);
    return data;
  },

  deleteComprador: async id => {
    const { data } = await axiosInstance.delete(`/api/compradores/${id}`);
    return data;
  },

  getCompradorTickets: async (id, skip, limit) => {
    const { data } = await axiosInstance.get(`/api/compradores/${id}/tickets/${skip}/${limit}`);
    return data;
  },
};

export default compradorService;
